import GridItem from "./grid-item.component";

export default GridItem;
